"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.personaFactory = void 0;
const Factory = require("factory.ts");
const persona_1 = require("../../../../mocks/persona");
const address_factory_1 = require("./address.factory");
const email_address_factory_1 = require("./email-address.factory");
const phone_number_factory_1 = require("./phone-number.factory");
exports.personaFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => i + 1),
    first_name: persona_1.persona.first_name,
    middle_name: null,
    last_name: persona_1.persona.last_name,
    date_of_birth: persona_1.persona.date_of_birth,
    gender: persona_1.persona.gender,
    nickname: null,
    suffix: null,
    graduation_year: null,
    address: address_factory_1.addressFactory.build(),
    phone_numbers: phone_number_factory_1.phoneNumberFactory.buildList(1),
    profile_images: persona_1.persona.profile_image,
    email_addresses: email_address_factory_1.emailAddressFactory.buildList(1),
});
